import { canonicalAppearance, encodeLook, randomLook } from '../../shared/appearance';
import { storage } from './storage';

/** The visitor's look lives only in this browser; a first visit or a reset gets a random one. */
export function savedLookCode(): number | null {
  const value = storage.get('appearance');
  return value === null ? null : canonicalAppearance(Number(value));
}
export function loadLookCode(): number {
  const saved = savedLookCode();
  if (saved !== null) return saved;
  const code = encodeLook(randomLook());
  storage.set('appearance', String(code));
  return code;
}
export function saveLookCode(code: number) { storage.set('appearance', String(code)); }
